/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UnlockedCurriculumTreeInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class UnlockedCurriculumTreeApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'UnlockedCurriculumTrees');
  }

  createUnlockedCurriculumTrees(
    unlockedCurriculumTrees: UnlockedCurriculumTreeInterface[]
  ): Observable<UnlockedCurriculumTreeInterface[]> {
    const path = 'createUnlockedCurriculumTrees';
    return this.post(path, undefined, unlockedCurriculumTrees);
  }

  deleteUnlockedCurriculumTrees(unlockedCurriculumTreeIds: number[]): Observable<UnlockedCurriculumTreeInterface[]> {
    const path = 'deleteUnlockedCurriculumTrees';
    return this.post(path, undefined, unlockedCurriculumTreeIds || []);
  }
}
